import type { FaireProductEntity } from "../../entity_types/product";

export const p_m9hpa8gf95: FaireProductEntity = {
  token: "p_m9hpa8gf95",
  type: "product",
  name: "Assorted Scented Incense Smudge Sticks",
  brandToken: "b_23nx3nnsvm",
  brandName: "Pacific Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/802ef1c2abc4bc6a3f0b647bc612f2aa7ef4de1f85fd238f800ce52e14df9f8c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee4c5ff04d6b9112d0c3b2beab0433d569e2900fbebfcfc60e4c2cd390bb3070.jpeg",
    "https://cdn.faire.com/fastly/e347a7806ec221d241aaf18f2420cd511715a0c2b92a492077ca492c4de91f31.jpeg",
    "https://cdn.faire.com/fastly/95ace90fc2816418b3d05b76b5a4a38d10ea1372840eb694a2281b19554b857b.jpeg",
    "https://cdn.faire.com/fastly/1b65046a4c29cd67d53fac9e79d126a46955dfa96301a72ecf85f33bf7f3d229.png",
    "https://cdn.faire.com/fastly/afc721d4ecf466e0885cc76e5e472dbb3c81b102a8acf8635852f3c2ada155dd.png",
    "https://cdn.faire.com/fastly/9c448d390ef57293cfdc8277c70ef15fc9f0bb4b56322c7c7ccb0c89653f703a.png",
  ],
  priceDollars: 5.54,
  description:
    'A unique blend of smudge herbs with incense.\nFragrance: Vanilla, Lavender, Palo Santo, and Frankincense\n16 sticks per box (4 Per Scent)\n\nPremium incense rolled with smudge herbs on bamboo sticks.\nApprox. 5 mm thick; 9" long.\nPure & Natural; Ethically sourced ingredients: Uplifts mind & spirit',
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:17.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
